import { Icon, Text } from '@mntn/ui-components'

export const NoDealsFound: React.FC = () => {
  return (
    <div className="flex flex-col items-center h-screen text-center gap-4 py-16">
      <Icon name="Box" className="text-secondary-accent-inverse size-14" />
      <Text variant="h5">No deals yet...</Text>
      <Text variant="sm-sb" className="text-secondary">
        Purchase deals in the Select platform. <br />
        Once deals are purchased, they will appear here.
      </Text>
    </div>
  )
}
